// ** reactstrap 9.2.3 removed Fade.defaultProps, but PopperContent (used by Tooltip and Popover)
// ** still reads it for its default transition, so transition.timeout ends up undefined and
// ** prop-types warns on every tooltip. Restore the 9.2.2 defaults until reactstrap fixes it.
import { PopperContent, Util } from "reactstrap"

if (PopperContent.defaultProps?.transition?.timeout === undefined) {
  PopperContent.defaultProps = {
    ...PopperContent.defaultProps,
    transition: {
      ...PopperContent.defaultProps?.transition,
      baseClass: "fade",
      baseClassActive: "show",
      timeout: Util.TransitionTimeouts.Fade
    }
  }
}
